import config from '@/config';
import { requests } from '.';
export const ContactServices = {
    searchContacts: (params, signal) => requests(config.CONTACTS_SERVICE_URL).post('/search', params, { signal }),
    createContact: params => requests(config.CONTACTS_SERVICE_URL).post('/?version=14-05-22', params),
    updateContact: (id, body) => requests(config.CONTACTS_SERVICE_URL).put(`/${id}`, body),
    validateEmail: (id) => requests(config.CONTACTS_SERVICE_URL).post(`/${id}/validateEmail/`),
    addTags: (id, tags) => requests(config.CONTACTS_SERVICE_URL).post(`/${id}/tags/`, { tags }),
    removeTags: (id, tags) => requests(config.CONTACTS_SERVICE_URL).delete(`/${id}/tags/`, {
        data: { tags },
    }),
    getAppointmentsForContact: (id) => requests(config.CONTACTS_SERVICE_URL).get(`/${id}/appointments`),
};
